import { render } from "./form-message-view.vue?vue&type=template&id=bdf51556"
import script from "./form-message-view.vue?vue&type=script&lang=js"
export * from "./form-message-view.vue?vue&type=script&lang=js"

import "./form-message-view.vue?vue&type=style&index=0&id=bdf51556&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__